import React from 'react'
import PropTypes from 'prop-types'
import NextHead from 'next/head'

import { compose, getContext } from '@hocs'

function BreadcrumbJsonLD(props) {
  let { breadcrumbLists } = props
  breadcrumbLists = breadcrumbLists.map((breadcrumbList) => ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbList.map((listItem, position) => ({
      '@type': 'ListItem',
      position: position + 1,
      ...listItem,
    })),
  }))
  if (breadcrumbLists.length === 1) breadcrumbLists = breadcrumbLists[0]
  return (
    <NextHead>
      <script
        key="BreadcrumbJsonLD"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbLists) }}
      />
    </NextHead>
  )
}

export default compose(
  getContext({
    router: PropTypes.shape().isRequired,
    breadcrumbLists: PropTypes.arrayOf(
      PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          item: PropTypes.string,
        }),
      ),
    ),
  }),
)(BreadcrumbJsonLD)
